import { lazy } from 'react';
import { useRoutes } from 'react-router-dom';

// project import
import Loadable from 'components/Loadable';
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import AdminRoutes from './AdminRoutes';

const NotFoundPage = Loadable(lazy(() => import('components/error_pages/error_404')));
const Support = Loadable(lazy(() => import('pages/authentication/Support')));

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  return useRoutes([
    MainRoutes,
    LoginRoutes,
    AdminRoutes,
    // Unguarded, unlike LoginRoutes' own children -- Support should be reachable whether or
    // not the visitor is signed in.
    { path: '/support', element: <Support /> },
    { path: '*', element: <NotFoundPage /> }
  ]);
}
